import React, { useEffect } from 'react';
import { FiCheck, FiLock, FiUnlock } from 'react-icons/fi';
import confetti from './img/confetti.svg';
import { LearningBlockNav, LearningBlockNavCheck, LearningBlockNavIcon, LearningBlockNavItem, LearningBlockNavTitle } from '@/components/custom/learning-block';

export function LearningPathBlockNav(props) {
  const { data, finished, setActiveSectionIndex, activeSectionIndex } = props;

  const getIndexOfClickedSection = id => {
    const index = data.findIndex(s => s.id === id);
    setActiveSectionIndex(index);
  };

  useEffect(() => {
    const index = data.findIndex(s => s.isActive || !s.done);
    if (index === -1) setActiveSectionIndex(0);
    else setActiveSectionIndex(index);
  }, [data]);

  return (
    <LearningBlockNav>
      {data.map((section, index, arr) => {
        const lastItem = arr.length - 1;
        const active = activeSectionIndex;

        return (
          <LearningBlockNavItem
            isActive={section.isActive}
            isSuccess={active === index}
            style={{ cursor: section.done || index === data.findIndex(s => !s.done) ? 'pointer' : 'default' }}
            key={index}
            onClick={() => {
              if (section.done || index === data.findIndex(s => !s.done)) getIndexOfClickedSection(section.id);
            }}
          >
            <LearningBlockNavIcon
              isActive={section.isActive}
              isSuccess={active === index}
              done={section.done}
            >
              {index === lastItem && finished ? (
                <img
                  src={confetti}
                  alt="confetes"
                />
              ) : (
                <>
                  {/* Mobile: numeral/check — sem cadeado, não passa ideia de bloqueio */}
                  <span className="lg:hidden">{section.done ? <FiCheck className="h-3.5 w-3.5" /> : index + 1}</span>
                  {/* Desktop: mantém o cadeado aberto/fechado do card original */}
                  <span className="hidden lg:inline-flex">{active === index || section.done ? <FiUnlock /> : <FiLock />}</span>
                </>
              )}
            </LearningBlockNavIcon>
            <LearningBlockNavTitle
              title={section.title}
              isSuccess={active === index}
            >
              {section.title === 'questions' ? 'Avaliação de conhecimento' : section.title}
            </LearningBlockNavTitle>
            <LearningBlockNavCheck
              checked={index === lastItem && finished ? true : section.done}
              readOnly
              isSuccess={active === index}
            />
          </LearningBlockNavItem>
        );
      })}
    </LearningBlockNav>
  );
}
